(function () {
  if (window.__customerClubRegisterInit) return;

  const form = document.querySelector('#customer-account-form');
  if (!form) return;

  window.__customerClubRegisterInit = true;

  const successURL = form.getAttribute('data-success-url');
  const actionURL = form.getAttribute('action');
  const loader = document.querySelector('#account-form-loader');

  const emailInput = document.getElementById('register-email');
  const passwordInput = document.getElementById('register-password');
  const phoneInput = document.getElementById('register-phone-national');
  const countrySelect = document.getElementById('register-phone-country');

  const newsletterToggle = document.getElementById('toggle-newsletter');
  const marketingPreferencesSection = document.getElementById('marketing-preferences-section');
  const smsToggle = document.getElementById('toggle-sms');
  const customerClubToggle = document.getElementById('toggle-customerclub');

  const editInfoButton = document.querySelector('[data-edit-info]');
  const translations = window.theme?.strings?.customer?.register?.errors || {};

  function getUTMParameters() {
    const urlParams = new URLSearchParams(window.location.search);
    return {
      utm_source: urlParams.get('utm_source') || '',
      utm_campaign: urlParams.get('utm_campaign') || '',
      utm_content: urlParams.get('utm_content') || ''
    };
  }

  function initializeMarketingPreferences() {
    if (newsletterToggle && newsletterToggle.checked) {
      showMarketingPreferences();
    }
  }

  function toggleMarketingPreferences() {
    if (!newsletterToggle) return;

    if (newsletterToggle.checked) {
      showMarketingPreferences();
      const hasExistingPreferences = getSelectedMarketingPreferences().length > 0;
      if (!hasExistingPreferences) {
        selectAllMarketingPreferences();
      }
    } else {
      hideMarketingPreferences();
      clearMarketingPreferences();
    }
  }

  function showMarketingPreferences() {
    if (marketingPreferencesSection) {
      marketingPreferencesSection.style.display = 'block';
    }
  }

  function hideMarketingPreferences() {
    if (marketingPreferencesSection) {
      marketingPreferencesSection.style.display = 'none';
    }
  }

  function clearMarketingPreferences() {
    const checkboxes = document.querySelectorAll('input[name="marketing_preferences"]');
    checkboxes.forEach(checkbox => {
      checkbox.checked = false;
    });
  }

  function selectAllMarketingPreferences() {
    const checkboxes = document.querySelectorAll('input[name="marketing_preferences"]');
    checkboxes.forEach(checkbox => {
      checkbox.checked = true;
    });
  }

  function addMarketingPreferenceListeners() {
    const preferenceCheckboxes = document.querySelectorAll('input[name="marketing_preferences"]');
    preferenceCheckboxes.forEach(checkbox => {
      checkbox.addEventListener('change', checkAndUpdateNewsletterState);
    });
  }

  const validateCustomerClub = () => {
    if (!customerClubToggle || !customerClubToggle.checked) {
      if (smsToggle) clearError(smsToggle.closest('.customer-club__form__field--container'));
      if (newsletterToggle) clearError(newsletterToggle.closest('.customer-club__form__field--container'));
      if (marketingPreferencesSection) clearError(marketingPreferencesSection);
      return true;
    }

    let isValid = true;

    if (newsletterToggle && newsletterToggle.checked) {
      const selectedPreferences = getSelectedMarketingPreferences();
      if (selectedPreferences.length === 0) {
        showError(marketingPreferencesSection, translations.marketing_preferences_required || 'Please select at least one marketing preference');
        isValid = false;
      } else {
        clearError(marketingPreferencesSection);
      }
    }

    return isValid;
  };

  const validateEmail = (input) => {
    if (!input) return false;

    const emailValue = input.value.trim();

    if (!emailValue) {
      showError(input, translations.email_required);
      return false;
    } else if (!isValidEmail(emailValue)) {
      showError(input, translations.invalid_email);
      return false;
    } else {
      clearError(input);
      return true;
    }
  };

  const isValidEmail = (email) => {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailPattern.test(email);
  };

  const validatePassword = (input) => {
    if (!input) return false;

    const passwordValue = input.value.trim();

    if (passwordValue.length < 6) {
      showError(input, translations.password);
      return false;
    } else {
      clearError(input);
      return true;
    }
  };

  const validatePhone = (input, countrySelectEl) => {
    if (!input || !countrySelectEl) return false;

    const phoneValue = input.value.trim();
    const selectedOption = countrySelectEl.selectedOptions && countrySelectEl.selectedOptions[0];
    if (!selectedOption) {
      showError(input, translations.invalid_phone);
      return false;
    }

    const countryCode = selectedOption.getAttribute('data-country');

    if (!window.libphonenumber) return showError(input, 'Something went wrong');
    const { parsePhoneNumberFromString, isValidPhoneNumber } = window.libphonenumber;

    if (phoneValue.startsWith('+')) {
      showError(input, translations.phone_countrycode);
      return false;
    }

    const phoneNumber = parsePhoneNumberFromString(phoneValue, countryCode);

    if (!phoneNumber) {
      showError(input, translations.invalid_phone);
      return false;
    } else if (!isValidPhoneNumber(phoneValue, countryCode)) {
      showError(input, translations.invalid_phone_country);
      return false;
    } else {
      clearError(input);
      return true;
    }
  };

  const showError = (input, messages) => {
    if (!input) return;

    let errorElement = input.nextElementSibling;
    if (!errorElement || !errorElement.classList.contains('error-message')) {
      errorElement = document.createElement('div');
      errorElement.className = 'error-message';
      if (input.parentNode) {
        input.parentNode.insertBefore(errorElement, input.nextSibling);
      }
    }

    const messageHTML = Array.isArray(messages)
      ? `<p>${messages.join(' ')}</p>`
      : `<p>${messages}</p>`;

    errorElement.innerHTML = messageHTML;
    input.classList.add('error');
  };

  const clearError = (input) => {
    if (!input) return;

    let errorElement = input.nextElementSibling;
    if (errorElement && errorElement.classList.contains('error-message')) {
      errorElement.remove();
    }
    input.classList.remove('error');
  };

  function createDummyRecaptchaForm(action, type) {
    const dummyRecaptchaForm = document.createElement('form');

    dummyRecaptchaForm.action = action;
    dummyRecaptchaForm.method = 'post';
    dummyRecaptchaForm.id = `dtails-hidden-recaptcha-trigger__${type}`;
    dummyRecaptchaForm.setAttribute('aria-hidden', 'true');
    dummyRecaptchaForm.style.display = 'none';

    const formTypeInput = document.createElement('input');

    formTypeInput.name = 'form_type';
    formTypeInput.setAttribute('value', type);

    dummyRecaptchaForm.appendChild(formTypeInput);

    return dummyRecaptchaForm;
  }

  function createLoginForm() {
    const loginForm = createDummyRecaptchaForm('/account/login', 'customer_login');
    const email = document.createElement('input');
    email.name = 'customer[email]';

    const password = document.createElement('input');
    password.name = 'customer[password]';

    const redirect = document.createElement('input');
    redirect.name = 'return_to';

    loginForm.appendChild(email);
    loginForm.appendChild(password);
    loginForm.appendChild(redirect);
    loginForm.setAttribute('aria-hidden', 'true');

    return loginForm;
  }

  function triggerFocusEvent(element) {
    const event = new Event('focusin', { bubbles: true, cancelable: false });
    element.dispatchEvent(event);
  }

  function triggerShopifyRecaptchaLoad(container) {
    const customerRecaptchaForm = createDummyRecaptchaForm('/account', 'create_customer');
    container.appendChild(customerRecaptchaForm);

    triggerFocusEvent(customerRecaptchaForm);
  }

  function injectHiddenForms() {
    if (document.getElementById('dtails_hidden_forms')) return;

    const container = document.createElement('div');

    container.id = 'dtails_hidden_forms';
    container.style.display = 'none';
    container.setAttribute('aria-hidden', 'true');

    document.body.appendChild(container);

    const loginForm = createLoginForm();

    container.appendChild(loginForm);

    if (window.Shopify?.captcha) {
      triggerShopifyRecaptchaLoad(container);
      window.Shopify.captcha.protect(loginForm);
    }
  }

  function getSelectedMarketingPreferences() {
    const selectedCheckboxes = document.querySelectorAll('input[name="marketing_preferences"]:checked');
    return Array.from(selectedCheckboxes).map(checkbox => checkbox.value);
  }

  function validateMarketingPreferences() {
    if (newsletterToggle && newsletterToggle.checked) {
      const selectedPreferences = getSelectedMarketingPreferences();
      if (selectedPreferences.length === 0) {
        showError(marketingPreferencesSection, translations.marketing_preferences_required || 'Please select at least one marketing preference');
        return false;
      } else {
        clearError(marketingPreferencesSection);
        return true;
      }
    }
    return true;
  }

  function checkAndUpdateNewsletterState() {
    if (newsletterToggle && newsletterToggle.checked) {
      const selectedPreferences = getSelectedMarketingPreferences();
      if (selectedPreferences.length === 0) {
        newsletterToggle.checked = false;
        hideMarketingPreferences();
        clearError(marketingPreferencesSection);
      }
    }
  }

  function setLoaderHidden(hidden) {
    if (loader) loader.hidden = hidden;
  }

  // Submit protection first: an init error below must not re-enable native submit.
  form.addEventListener('submit', async (e) => {
    e.preventDefault();

    const register = passwordInput === null ? false : true;
    let isFormValid = true;

    if (!validateCustomerClub()) isFormValid = false;
    if (!validateMarketingPreferences()) isFormValid = false;
    if (!validatePhone(phoneInput, countrySelect)) isFormValid = false;
    if (!validateEmail(emailInput)) isFormValid = false;

    if (register) {
      if (!validatePassword(passwordInput)) isFormValid = false;
    }

    if (!isFormValid) return false;

    const formData = new FormData(form);
    setLoaderHidden(false);
    let customerData = {};

    if (register) {
      const formattedChildren = [];
      const childForms = document.querySelectorAll('child-form form');
      for (let i = 0; i < childForms.length; i++) {
        const childForm = childForms[i];
        if (!childForm.checkValidity()) {
          setLoaderHidden(true);
          return childForm.reportValidity();
        }
      }

      childForms.forEach(childForm => {
        const childFormData = new FormData(childForm);
        formattedChildren.push({
          first_name: childFormData.get('child_name').split(' ')[0],
          last_name: childFormData.get('child_name').split(' ').slice(1).join(' '),
          gender: childFormData.get('child_gender'),
          relation: childFormData.get('child_relation'),
          birthdate: childFormData.get('child_birthdate')
        });
      });

      customerData = {
        address: formData.get('address1'),
        city: formData.get('city'),
        zip: formData.get('zip'),
        password: formData.get('password'),
        phone: `+${formData.get('phone_country')}${formData.get('phone_national')}`,
        first_name: formData.get('first_name'),
        last_name: formData.get('last_name'),
        country: formData.get('country'),
        email: formData.get('email'),
        member: formData.has('clubstatus'),
        marketing_preferences: getSelectedMarketingPreferences(),
        sms: formData.has('sms'),
        children: formattedChildren,
        ...(formData.has('gender') ? { gender: formData.get('gender') } : {}),
        ...(formData.has('birthdate') && formData.get('birthdate') !== '' ? { birthdate: formData.get('birthdate') } : {}),
        ...(formData.has('store') ? { store: formData.get('store') } : {})
      };
    } else {
      customerData = {
        first_name: formData.get('first_name'),
        last_name: formData.get('last_name'),
        phone: `+${formData.get('phone_country')}${formData.get('phone_national')}`,
        email: formData.get('email'),
        member: formData.has('clubstatus'),
        marketing_preferences: getSelectedMarketingPreferences(),
        sms: formData.has('sms'),
        address: {
          address: formData.get('address1'),
          country: formData.get('country'),
          city: formData.get('city'),
          zip: formData.get('zip'),
        },
        ...(formData.has('gender') ? { gender: formData.get('gender') } : {}),
        ...(formData.has('birthdate') && formData.get('birthdate') !== '' ? { birthdate: formData.get('birthdate') } : {}),
        ...(formData.has('store') ? { store: formData.get('store') } : {})
      };
    }

    try {
      const response = await fetch(actionURL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(customerData)
      });

      if (response.status === 422) {
        throw await response.json();
      }

      console.log('datalayer start');

      if (!response.ok) {
        throw new Error('Network response was not okay');
      }

      window.dataLayer = window.dataLayer || [];
      const utmParams = getUTMParameters();
      window.dataLayer.push({
        event: 'customer_club_signup',
        signup_type: register ? 'registration' : 'update',
        club_opt_in: customerClubToggle ? customerClubToggle.checked : false,
        utm_source: utmParams.utm_source,
        utm_campaign: utmParams.utm_campaign,
        utm_content: utmParams.utm_content
      });

      console.log('datalayer pushed successfully');
      console.log('datalayer', window.dataLayer);

      setTimeout(() => {
        if (register) {
          const hiddenLoginForm = document.getElementById('dtails-hidden-recaptcha-trigger__customer_login');
          if (hiddenLoginForm) {
            const emailField = hiddenLoginForm.querySelector('[name="customer[email]"]');
            const passwordField = hiddenLoginForm.querySelector('[name="customer[password]"]');
            const returnToField = hiddenLoginForm.querySelector('[name="return_to"]');

            if (emailField) emailField.value = customerData.email;
            if (passwordField) passwordField.value = customerData.password;
            if (successURL && returnToField) returnToField.value = successURL;

            hiddenLoginForm.submit();
            return;
          }

          window.location.href = successURL || '/account';
        } else {
          window.location.reload();
        }
      }, 1500);
    } catch (error) {
      setLoaderHidden(true);
      if (error && typeof error === 'object' && error.errors) {
        if (Object.prototype.hasOwnProperty.call(error.errors, 'phone')) {
          showError(phoneInput, translations.tel_exists);
        }

        if (Object.prototype.hasOwnProperty.call(error.errors, 'email')) {
          showError(emailInput, [translations.email_exists, translations.recommendation]);
        }

        if (Object.prototype.hasOwnProperty.call(error.errors, 'account')) {
          showError(emailInput, [translations.account_disabled]);
        }

        window.scrollTo({ top: 0, behavior: 'instant' });
      } else {
        console.error(error);
      }
    }
  });

  try {
    editInfoButton?.addEventListener('click', () => {
      const profileView = document.querySelector('[data-profile]');
      const editProfileView = document.querySelector('[data-edit-profile]');

      if (profileView) profileView.hidden = true;
      if (editProfileView) editProfileView.hidden = false;

      initializeMarketingPreferences();
      addMarketingPreferenceListeners();
    });

    phoneInput?.addEventListener('change', () => {
      validatePhone(phoneInput, countrySelect);
    });

    emailInput?.addEventListener('change', () => {
      validateEmail(emailInput);
    });

    passwordInput?.addEventListener('change', function () {
      validatePassword(passwordInput);
    });

    countrySelect?.addEventListener('change', () => {
      if (!phoneInput || phoneInput.value === '') return;
      validatePhone(phoneInput, countrySelect);
    });

    newsletterToggle?.addEventListener('change', () => {
      toggleMarketingPreferences();
    });

    if (newsletterToggle) {
      initializeMarketingPreferences();
      addMarketingPreferenceListeners();
    }

    if (passwordInput !== null) {
      injectHiddenForms();
    }

    if (window.Shopify?.CountryProvinceSelector) {
      new window.Shopify.CountryProvinceSelector('register-country', 'register-province', {
        hideElement: 'province-container',
      });
    }
  } catch (error) {
    console.error('Customer club register init failed:', error);
  }
})();
